import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { CalAngularService, ICvxClaimsPrincipal } from '@cvx/cal-angular';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'CNC-MB-Reports-UI';

  currentUserProfile: ICvxClaimsPrincipal | null = null;
  isLoggedIn = false;

  constructor(private authService: CalAngularService) {
    this.login();
  }

  ngOnInit(): void { }

  private async login(): Promise<void> {
    const user = await firstValueFrom(this.authService.userInitiatedSignIn());
    this.isLoggedIn = user?.isUser ?? false;
    if (!this.isLoggedIn) return;

    this.currentUserProfile = this.authService.cvxClaimsPrincipal;
  }
}
